export const INIT = "INIT";
export function initUser(data) {
    return { type: INIT, data }
}


// WEBPACK FOOTER //
// ./src/services/store/reducers/user/actions.js